import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageComponent } from '@app/v2/components/page/page.component';

import { AnnouncementService } from '@app/v2/services/announcement/announcement.service';

import { PaymentRequestStatus } from '@models/request';
import { AdminRequestServices } from '@services/admin/admin-request.service';
import { getModalConfig, ModalSize } from '@utility/modal-helper';
import { rxjsEffect } from '@utility/utility';
import { combineLatest, map, take, tap } from 'rxjs';
import { DisplayAnnouncementDialogComponent } from '../dialogs/display-announcement-dialog/display-announcement-dialog.component';
import { SitesListComponent } from '../sites-list/sites-list.component';

@Component({
    selector: 'medpace-crc-dashboard',
    imports: [PageComponent, SitesListComponent],
    templateUrl: './crc-dashboard.page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrcDashboardPageComponent {
    private readonly requestService = inject(AdminRequestServices);
    private readonly matDialog = inject(MatDialog);
    private readonly announcementService = inject(AnnouncementService);

    public readonly routeStatuses: InputSignal<number[] | undefined> = input<number[] | undefined>(undefined);

    private readonly crcShowRedirectToReimbursementRequests$ = this.requestService
        .getCrcUserReimbursementRequestCount([PaymentRequestStatus.PendingSiteVerification])
        .pipe(
            map((numberOfPendingRequests) => {
                let showRedirectToRequest = sessionStorage.getItem('showRedirectToRequests');
                if (showRedirectToRequest === 'false') return false;

                return !!numberOfPendingRequests && numberOfPendingRequests > 0;
            })
        );

    constructor() {
        // show announcements if they exist
        rxjsEffect(() =>
            combineLatest([
                this.crcShowRedirectToReimbursementRequests$,
                this.announcementService.getAnnouncementsToDisplay(),
            ]).pipe(
                take(1),
                tap(([crcShowRedirectToReimbursementRequests, announcements]) => {
                    if (announcements.length != 0 || crcShowRedirectToReimbursementRequests) {
                        this.matDialog.open(DisplayAnnouncementDialogComponent, {
                            data: {
                                announcements: announcements,
                                showRedirectToRequests: crcShowRedirectToReimbursementRequests,
                            },
                            ...getModalConfig(ModalSize.Small),
                        });
                    }
                })
            )
        );
    }
}
